
<span
  :style="{
    padding: '3px 8px',
    backgroundColor: statusStyle.background,
    color: statusStyle.color,
    border: borderStyle,
    borderRadius: '10px',
    fontWeight: '700',
    fontSize: '14px',
    textTransform: 'capitalize',
    whiteSpace: 'nowrap',
    display: 'inline-block',
    width: 'fit-content',
    lineHeight: '1.5',
  }"
  :class="$attrs.class"
>
  <slot>
    {{ label }}
  </slot>
</span>
